import ImageReviews from './ImageReviews'

export default ImageReviews
